import { Input } from '@zendeskgarden/react-forms'
import { ComponentProps, useEffect, useRef } from 'react'
import { useIMask } from 'react-imask'

/** @deprecated Use TextField instead */
export function TextFieldV1({
    mask,
    onPaste,
    onChange,
    ...props
}: ComponentProps<typeof Input> & { mask?: string }) {
    const { ref, value } = useIMask({ mask })

    const onChangeRef = useRef(onChange)
    onChangeRef.current = onChange

    useEffect(() => {
        // putting it in a useEffect allows the value to be updated on paste as well
        onChangeRef.current?.({ target: { value } } as any)
    }, [value])

    return <Input {...props} ref={ref as any} />
}
